export { default } from './WindStationMap';
